define('../app/fukit/lib/url.change.tracker',['require','exports','module','backbone','underscore'],function(require, exports, module) {
  //prettier-ignore
  var Backbone  = require('backbone'),
      _         = require('underscore'),
      ga        = window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};

  ga.l = +new Date();

  var utilities = {
    /**
     * Accepts default and user override fields and an optional tracker, hit
     * filter, and target element and returns a single object that can be used in
     * `ga('send', ...)` commands.
     * @param {Object} defaultFields The default fields to return.
     * @param {Object} userFields Fields set by the user to override the defaults.
     * @param {Object} opt_tracker The tracker object to apply the hit filter to.
     * @param {Function} opt_hitFilter A filter function that gets
     *     called with the tracker model right before the `buildHitTask`. It can
     *     be used to modify the model for the current hit only.
     * @param {Element} opt_target If the hit originated from an interaction
     *     with a DOM element, hitFilter is invoked with that element as the
     *     second argument.
     * @return {Object} The final fields object.
     */
    createFieldsObj: function(defaultFields, userFields, opt_tracker, opt_hitFilter, opt_target) {
      if (typeof opt_hitFilter == 'function') {
        var originalBuildHitTask = opt_tracker.get('buildHitTask');
        return {
          buildHitTask: function(model) {
            model.set(defaultFields, null, true);
            model.set(userFields, null, true);
            opt_hitFilter(model, opt_target);
            originalBuildHitTask(model);
          },
        };
      } else {
        return _.extend({}, defaultFields, userFields);
      }
    },
  };

  function getPath() {
    return location.pathname + location.search + location.hash;
  }

  function UrlChangeTracker(tracker, options) {
    this.options = _.extend(
      {
        fieldsObj: {},
        hitFilter: null,
      },
      options
    );
    this.tracker = tracker;
    this.path = getPath();
    Backbone.history.on(
      'route',
      _.debounce(function() {
        this.onRoute();
      }),
      this
    );
  }

  UrlChangeTracker.prototype.onRoute = function(shouldSendPageview) {
    shouldSendPageview = shouldSendPageview === false ? false : true;

    //prettier-ignore
    var oldPath = this.path,
        newPath = getPath();

    if (oldPath != newPath && this.shouldTrackUrlChange(newPath, oldPath)) {
      this.path = newPath;
      this.tracker.set({
        page: newPath,
        title: (_.isObject(history.state) && history.state.title) || document.title,
      });

      if (shouldSendPageview) {
        var defaultFields = { transport: 'beacon' };
        this.tracker.send(
          'pageview',
          utilities.createFieldsObj(defaultFields, this.options.fieldsObj, this.tracker, this.options.hitFilter)
        );
      }
    }
  };

  UrlChangeTracker.prototype.shouldTrackUrlChange = function(newPath, oldPath) {
    return newPath && oldPath;
  };

  ga('provide', 'urlChangeTracker', UrlChangeTracker);
});

